import GeoProvider from '../../components/GeoProvider'
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { startDate, endDate, displayDate } from './dates'
import dataDisplayOptions from './dataDisplayOptions'
import FluMap from './FluMap'
import styles from './FluMeter.module.scss'
// import { useAuthState } from '../../components/AuthProvider'
import activityLog from '../../utils/activityLog'
import InitReactorCX from '../../components/Reactor/optumReactorCX' 

const FluMeter = () => {
  // const { user } = useAuthState()
  useEffect(() => {
    InitReactorCX();
  },[]);

  const location = useLocation();
  const NAMESPACE_OPTUM_REACTOR = process.env.REACT_APP_NAMESPACE_OPTUM_REACTOR;

  useEffect(() => {
    if (location.pathname.length > 1) {
      const custom_data_object = {"namespace": NAMESPACE_OPTUM_REACTOR, "application_viewUrl": location.pathname}
      if (typeof window !== 'undefined' && window.hasOwnProperty("Rakanto") && window.Rakanto.hasOwnProperty('event')) {
        window.Rakanto.event("sendCustomData", custom_data_object);
      }
    }
  }, [location]);

  var url = window.location.href
  var name = 'Flu Meter'
  if (url.indexOf('flumeter') !== -1) name = 'Flu Meter'

  return (
    <div className={styles.base}>
      <div className={styles.heading}>
        <h4>Forecasted Flu Activity</h4>
       
      </div>
      <GeoProvider
        startDate={startDate}
        endDate={endDate}
        displayDate={displayDate}
        mapOptions={dataDisplayOptions[0]['options'][0]}
      >
        <FluMap />
      </GeoProvider>
      <div className={styles.footer}>
        <p>
        The content, forecasts, and predictions offered may be AI-generated and 
              are for informational purposes only, and nothing in the forecasts, 
              predictions and related information should be considered,
              or used as a substitute for, medical advice, diagnosis or treatment. Users
              should seek the advice of a physician or other qualified health
              care provider with any questions regarding personal health or
              medical conditions. Optum and its affiliates and licensors make no
              representations or warranties of any kind, express or implied,
              with respect to these forecasts, predictions, any related data,
              and/or the techniques used to create such forecasts and
              predictions, including, but not limited to, any warranties of
              performance, merchantability, fitness for a particular purpose,
              title/non-infringement, and quality, accuracy and/or completeness
              of these forecasts, predictions, and related information. Any
              interpretation or use of these forecasts, predictions, and related
              information is solely and exclusively at your own discretion and
              risk, and Optum and its affiliates and licensors will have no
              liability for any damages or claims relating to such
              interpretation or use.
        </p>
      </div>
    </div>
  )
}

export default FluMeter
